import _createForOfIteratorHelper from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _classCallCheck from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createClass.js";
import ue from "../models/braze-event.js";
import _t from "../models/identifier.js";
import { isArray as D, keys as C, validateValueIsFromEnum as ta, values as Pt } from "../util/code-utils.js";
import { logger as E, EventTypes as m } from "../../shared-lib/index.js";
import { User } from "../User/index.js";
import ro from "../util/browser-detector.js";
import { getErrorMessage as si } from "../util/error-utils.js";
export var STORAGE_KEYS = {
  iu: {
    su: "ab.storage.userId",
    Jh: "ab.storage.deviceId",
    Nl: "ab.storage.sessionId"
  },
  ct: {
    ec: "ab.test",
    tE: "ab.storage.events",
    eE: "ab.storage.attributes",
    sE: "ab.storage.attributes.anonymous_user",
    Qa: "ab.storage.device",
    au: "ab.storage.sdk_metadata",
    du: "ab.storage.session_id_for_cached_metadata",
    In: "ab.storage.pushToken",
    rE: "ab.storage.cardImpressions",
    hl: "ab.storage.serverConfig",
    oE: "ab.storage.triggers",
    nE: "ab.storage.triggers.ts",
    Hl: "ab.storage.messagingSessionStart",
    Ps: "ab.storage.cc",
    Gs: "ab.storage.ccLastFullSync",
    Hs: "ab.storage.ccLastCardUpdated",
    Pu: "ab.storage.globalRateLimitCurrentTokenCount",
    Hu: "ab.storage.dynamicRateLimitCurrentTokenCount",
    Et: "ab.storage.ccClicks",
    Pt: "ab.storage.ccImpressions",
    Lt: "ab.storage.ccDismissals",
    aE: "ab.storage.lastDisplayedTriggerTimesById",
    iE: "ab.storage.lastDisplayedTriggerTime",
    EE: "ab.storage.triggerFireInstancesById",
    jh: "ab.storage.signature",
    lE: "ab.storage.brazeSyncRetryCount",
    Qs: "ab.storage.sdkVersion",
    Ie: "ab.storage.ff",
    qe: "ab.storage.ffImpressions",
    Ae: "ab.storage.ffLastRefreshAt",
    Me: "ab.storage.ff.sessionId",
    SE: "ab.storage.lastReqToEndpoint",
    _E: "ab.storage.requestAttempts",
    Nr: "ab.storage.deferredIam",
    Lu: "ab.storage.lastSdkReq",
    uE: "ab.storage.alias",
    ut: "ab.storage.banners",
    It: "ab.storage.banners.impressions",
    gt: "ab.storage.banners.sessionId"
  },
  ie: "ab.optOut"
};
var ee = /*#__PURE__*/function () {
  function ee(t, e) {
    _classCallCheck(this, ee);
    this.cE = t, this.TE = e, this.cE = t, this.TE = e;
  }
  _createClass(ee, [{
    key: "Da",
    value: function Da(t) {
      var e = C(STORAGE_KEYS.iu),
        s = new ee.ne(t);
      var _iterator = _createForOfIteratorHelper(e),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _t2 = _step.value;
          s.remove(STORAGE_KEYS.iu[_t2]);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "uu",
    value: function uu(t, e) {
      var s = null;
      null != e && e instanceof _t && (s = e.dt()), this.cE.store(t, s);
    }
  }, {
    key: "hE",
    value: function hE(t) {
      var e = this.tu(t);
      null != e && (e.ql = new Date().valueOf(), this.uu(t, e));
    }
  }, {
    key: "tu",
    value: function tu(t) {
      var e = this.cE.br(t),
        s = function (t) {
          var e;
          try {
            e = JSON.parse(t);
          } catch (t) {
            e = null;
          }
          return e;
        }(e);
      var r;
      if (s) r = _t.qn(s) || null, r && this.uu(t, r);else {
        var _s = _t.AE(e);
        r = _t.qn(_s) || null, _s !== e && r && this.uu(t, r);
      }
      return r;
    }
  }, {
    key: "Fl",
    value: function Fl(t) {
      this.cE.remove(t);
    }
  }, {
    key: "Ua",
    value: function Ua() {
      var t = C(STORAGE_KEYS.iu);
      var e;
      var _iterator2 = _createForOfIteratorHelper(t),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var s = _step2.value;
          e = this.tu(STORAGE_KEYS.iu[s]), null != e && this.uu(STORAGE_KEYS.iu[s], e);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, {
    key: "Eo",
    value: function Eo(t) {
      var e;
      if (null == t || 0 === t.length) return !1;
      e = D(t) ? t : [t];
      var s = this.TE.br(STORAGE_KEYS.ct.tE);
      null != s && D(s) || (s = []);
      for (var _t3 = 0; _t3 < e.length; _t3++) s.push(e[_t3].dt());
      return this.TE.store(STORAGE_KEYS.ct.tE, s);
    }
  }, {
    key: "yl",
    value: function yl(t) {
      return null != t && this.Eo([t]);
    }
  }, {
    key: "RE",
    value: function RE() {
      var t = this.TE.br(STORAGE_KEYS.ct.tE);
      this.TE.remove(STORAGE_KEYS.ct.tE), null == t && (t = []);
      var e = [];
      var s = !1,
        r = null;
      if (D(t)) for (var _s2 = 0; _s2 < t.length; _s2++) ue.gE(t[_s2]) ? e.push(ue.qn(t[_s2])) : r = _s2;else s = !0;
      if (s || null != r) {
        var o = "Stored events could not be deserialized as Events";
        s && (o += ", was " + Object.prototype.toString.call(t) + " not an array"), null != r && (o += ", value at index " + r + " does not look like an event"), o += ", serialized values were of type " + typeof t + ": " + JSON.stringify(t), e.push(new ue(null, m.pu, new Date().valueOf(), null, {
          e: o
        }));
      }
      return e;
    }
  }, {
    key: "ft",
    value: function ft(t, e) {
      return !!ta(STORAGE_KEYS.ct, t, "StorageManager cannot store object.", "STORAGE_KEYS.OBJECTS") && this.TE.store(t, e);
    }
  }, {
    key: "lt",
    value: function lt(t) {
      return !!ta(STORAGE_KEYS.ct, t, "StorageManager cannot retrieve object.", "STORAGE_KEYS.OBJECTS") && this.TE.br(t);
    }
  }, {
    key: "Nt",
    value: function Nt(t) {
      return !!ta(STORAGE_KEYS.ct, t, "StorageManager cannot remove object.", "STORAGE_KEYS.OBJECTS") && (this.TE.remove(t), !0);
    }
  }, {
    key: "clearData",
    value: function clearData() {
      var t = C(STORAGE_KEYS.iu),
        e = C(STORAGE_KEYS.ct);
      for (var _e = 0; _e < t.length; _e++) {
        var s = t[_e];
        this.cE.remove(STORAGE_KEYS.iu[s]);
      }
      for (var _t4 = 0; _t4 < e.length; _t4++) {
        var _s3 = e[_t4];
        this.TE.remove(STORAGE_KEYS.ct[_s3]);
      }
    }
  }, {
    key: "OE",
    value: function OE(t) {
      return t || STORAGE_KEYS.ct.sE;
    }
  }, {
    key: "ku",
    value: function ku(t) {
      var e = this.TE.br(STORAGE_KEYS.ct.eE);
      null == e && (e = {});
      var s = this.OE(t[User.Jn]),
        r = e[s];
      for (var o in t) o !== User.Jn && (null == e[s] || r && null == r[o]) && this.mu(t[User.Jn], o, t[o]);
    }
  }, {
    key: "mu",
    value: function mu(t, e, s) {
      var r = this.TE.br(STORAGE_KEYS.ct.eE);
      null == r && (r = {});
      var o = this.OE(t);
      var n = r[o];
      if (null == n && (n = {}, null != t && (n[User.Jn] = t)), e === User.lu) {
        null == n[e] && (n[e] = {});
        for (var _t5 in s) n[e][_t5] = s[_t5];
      } else n[e] = s;
      return r[o] = n, this.TE.store(STORAGE_KEYS.ct.eE, r);
    }
  }, {
    key: "IE",
    value: function IE() {
      var t = this.TE.br(STORAGE_KEYS.ct.eE);
      this.TE.remove(STORAGE_KEYS.ct.eE);
      var e = [];
      for (var s in t) null != t[s] && e.push(t[s]);
      return e;
    }
  }, {
    key: "ru",
    value: function ru(t) {
      var e = this.TE.br(STORAGE_KEYS.ct.eE);
      if (null != e) {
        var _s4 = this.OE(null),
          _r = e[_s4];
        null != _r && (e[_s4] = void 0, this.TE.store(STORAGE_KEYS.ct.eE, e), _r[User.Jn] = t, this.ku(_r));
      }
      var s = this.tu(STORAGE_KEYS.iu.Nl);
      var r = null;
      null != s && (r = s.eu);
      var o = this.RE();
      if (null != o) for (var _e2 = 0; _e2 < o.length; _e2++) {
        var _s5 = o[_e2];
        null == _s5.userId && _s5.sessionId == r && (_s5.userId = t), this.yl(_s5);
      }
    }
  }, {
    key: "dE",
    value: function dE() {
      return this.TE.fE;
    }
  }]);
  return ee;
}();
export { ee as default };
ee.rc = /*#__PURE__*/function () {
  function _class(t) {
    _classCallCheck(this, _class);
    this.sn = t, this.sn = t, this.fE = ro.bE() ? 3 : 10;
  }
  _createClass(_class, [{
    key: "mE",
    value: function mE(t) {
      return t + "." + this.sn;
    }
  }, {
    key: "store",
    value: function store(t, e) {
      var s = {
        v: e
      };
      try {
        return localStorage.setItem(this.mE(t), JSON.stringify(s)), !0;
      } catch (t) {
        return E.info("Storage failure: " + si(t)), !1;
      }
    }
  }, {
    key: "br",
    value: function br(t) {
      try {
        var e = null;
        var s = localStorage.getItem(this.mE(t));
        return null != s && (e = JSON.parse(s)), null == e ? null : e.v;
      } catch (t) {
        return E.info("Storage retrieval failure: " + si(t)), null;
      }
    }
  }, {
    key: "remove",
    value: function remove(t) {
      try {
        localStorage.removeItem(this.mE(t));
      } catch (t) {
        return E.info("Storage removal failure: " + si(t)), !1;
      }
    }
  }]);
  return _class;
}(), ee.ac = /*#__PURE__*/function () {
  function _class2() {
    _classCallCheck(this, _class2);
    this.KE = {}, this.YE = 5242880, this.fE = 3;
  }
  _createClass(_class2, [{
    key: "store",
    value: function store(t, e) {
      var s = {
          value: e
        },
        r = this.NE(e);
      return r > this.YE ? (E.info("Storage failure: object is ≈" + r + " bytes which is greater than the max of " + this.YE), !1) : (this.KE[t] = s, !0);
    }
  }, {
    key: "NE",
    value: function NE(t) {
      var e = [],
        s = [t];
      var r = 0;
      for (; s.length;) {
        var _t6 = s.pop();
        if ("boolean" == typeof _t6) r += 4;else if ("string" == typeof _t6) r += 2 * _t6.length;else if ("number" == typeof _t6) r += 8;else if ("object" == typeof _t6 && -1 === e.indexOf(_t6)) {
          var _r2 = void 0,
            o = void 0;
          e.push(_t6);
          for (var _e3 in _t6) o = _t6, _r2 = _e3, s.push(o[_r2]);
        }
      }
      return r;
    }
  }, {
    key: "br",
    value: function br(t) {
      var e = this.KE[t];
      return null == e ? null : e.value;
    }
  }, {
    key: "remove",
    value: function remove(t) {
      this.KE[t] = null;
    }
  }]);
  return _class2;
}(), ee.ne = /*#__PURE__*/function () {
  function _class3(t, e) {
    _classCallCheck(this, _class3);
    this.sn = t, this.GE = e, this.sn = t, this.CE = this.DE(), this.ME = 576e3, this.GE = !!e;
  }
  _createClass(_class3, [{
    key: "mE",
    value: function mE(t) {
      return null != this.sn ? t + "." + this.sn : t;
    }
  }, {
    key: "DE",
    value: function DE() {
      var t = 0,
        e = document.location.hostname;
      var s = e.split("."),
        r = "ab._gd";
      for (; t < s.length - 1 && -1 === document.cookie.indexOf(r + "=" + r);) t++, e = "." + s.slice(-1 - t).join("."), document.cookie = r + "=" + r + ";domain=" + e + ";";
      return document.cookie = r + "=;expires=" + new Date(0).toUTCString() + ";domain=" + e + ";", e;
    }
  }, {
    key: "se",
    value: function se() {
      var t = new Date();
      return t.setTime(t.getTime() + 60 * this.ME * 1e3), t.getFullYear();
    }
  }, {
    key: "pE",
    value: function pE() {
      var t = Pt(STORAGE_KEYS.iu),
        e = document.cookie.split(";");
      for (var s = 0; s < e.length; s++) {
        var r = e[s];
        for (; " " === r.charAt(0);) r = r.substring(1);
        var o = !1;
        for (var _e4 = 0; _e4 < t.length; _e4++) if (0 === r.indexOf(t[_e4])) {
          o = !0;
          break;
        }
        if (o) {
          var _t7 = r.split("=")[0];
          -1 === _t7.indexOf("." + this.sn) && this.vE(_t7);
        }
      }
    }
  }, {
    key: "store",
    value: function store(t, e) {
      this.pE();
      var s = new Date();
      s.setTime(s.getTime() + 60 * this.ME * 1e3);
      var r = "expires=" + s.toUTCString(),
        o = "domain=" + this.CE;
      var n;
      n = this.GE ? e : encodeURIComponent(e);
      var a = this.mE(t) + "=" + n + ";" + r + ";" + o + ";path=/";
      return a.length >= 4093 ? (E.info("Storage failure: string is " + a.length + " chars which is too large to store as a cookie."), !1) : (document.cookie = a, !0);
    }
  }, {
    key: "br",
    value: function br(t) {
      var e = [],
        s = this.mE(t) + "=",
        r = document.cookie.split(";");
      for (var o = 0; o < r.length; o++) {
        var n = r[o];
        for (; " " === n.charAt(0);) n = n.substring(1);
        if (0 === n.indexOf(s)) try {
          var _t8 = void 0;
          _t8 = this.GE ? n.substring(s.length, n.length) : decodeURIComponent(n.substring(s.length, n.length)), e.push(_t8);
        } catch (e) {
          return E.info("Storage retrieval failure: " + si(e)), this.remove(t), null;
        }
      }
      return e.length > 0 ? e[e.length - 1] : null;
    }
  }, {
    key: "remove",
    value: function remove(t) {
      this.vE(this.mE(t));
    }
  }, {
    key: "vE",
    value: function vE(t) {
      var e = t + "=;expires=" + new Date(0).toUTCString();
      document.cookie = e, document.cookie = e + ";path=/";
      var s = e + ";domain=" + this.CE;
      document.cookie = s, document.cookie = s + ";path=/";
    }
  }]);
  return _class3;
}(), ee.tc = /*#__PURE__*/function () {
  function _class4(t, e, s) {
    _classCallCheck(this, _class4);
    this.sn = t, this.UE = [], e && this.UE.push(new ee.ne(t)), s && this.UE.push(new ee.rc(t)), this.UE.push(new ee.ac());
  }
  _createClass(_class4, [{
    key: "store",
    value: function store(t, e) {
      var s = !0;
      for (var r = 0; r < this.UE.length; r++) s = this.UE[r].store(t, e) && s;
      return s;
    }
  }, {
    key: "br",
    value: function br(t) {
      for (var e = 0; e < this.UE.length; e++) {
        var s = this.UE[e].br(t);
        if (null != s) return s;
      }
      return null;
    }
  }, {
    key: "remove",
    value: function remove(t) {
      new ee.ne(this.sn).remove(t);
      for (var e = 0; e < this.UE.length; e++) this.UE[e].remove(t);
    }
  }]);
  return _class4;
}();